import { render } from "./SectionEditor.vue?vue&type=template&id=34fd3564&scoped=true"
import script from "./SectionEditor.vue?vue&type=script&lang=js"
export * from "./SectionEditor.vue?vue&type=script&lang=js"

import "./SectionEditor.vue?vue&type=style&index=0&id=34fd3564&scoped=true&lang=css"

import exportComponent from "/var/www/matchmaker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34fd3564"]])

export default __exports__